import { lazy } from 'react';
import { DashboardLayout } from '../../../app/components';
import { routingPath } from '../../../app/routes';

const BalancePage = lazy(() =>
  import('../pages/BalancePage').then((m) => ({ default: m.BalancePage })),
);
const BankStatementPage = lazy(() =>
  import('../pages/BankStatement').then((m) => ({
    default: m.BankStatementPage,
  })),
);

const DisbursementRoutes = () => {
  return {
    element: <DashboardLayout />,
    children: [
      {
        path: routingPath.disbursement.balance,
        element: <BalancePage />,
      },
      {
        path: routingPath.disbursement.statement,
        element: <BankStatementPage />,
      },
    ],
  };
};

export default DisbursementRoutes;
